import request from '@/utils/request'

export const getSubcontractors = params => request.get('/accounting/subcontractors', { params })

export const createSubcontractor = data => request.post('/accounting/subcontractors', data)

export const getSubcontractor = id => request.get(`/accounting/subcontractors/${id}`)

export const updateSubcontractor = (id, data) => request.put(`/accounting/subcontractors/${id}`, data)

export const deleteSubcontractor = id => request.delete(`/accounting/subcontractors/${id}`)

export const getSubcontractorStatement = (id, params) => request.get(`/accounting/subcontractors/${id}/statement`, { params })

export const paySubcontractor = (id, data) => request.post(`/accounting/subcontractors/${id}/payments`, data)

export const getSubcontractBills = params => request.get('/accounting/subcontract-bills', { params })

export const createSubcontractBill = data => request.post('/accounting/subcontract-bills', data)

export const getSubcontractBill = id => request.get(`/accounting/subcontract-bills/${id}`)

export const cancelSubcontractBill = id => request.post(`/accounting/subcontract-bills/${id}/cancel`)

export const releaseSubcontractRetention = (id, data) => request.post(`/accounting/subcontract-bills/${id}/release-retention`, data || {})
